import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { AppRoute } from '@shared/config'

import { useAuthStore } from './store'
import { buildLoginLocation, resolvePostLoginPath } from './login-redirect'

import { navigateTo } from '#app'

export const useMiddlewareAuth = async (to: RouteLocationNormalizedGeneric) => {
  const auth = useAuthStore()

  if (!auth.accessToken) auth._hydrateFromStorage()

  const isLogin = to.path === AppRoute.Login

  if (auth.accessToken && auth.secondsLeft() > 0) {
    if (isLogin) return navigateTo(resolvePostLoginPath(to.query))
    return
  }

  if (auth.refreshToken) {
    const token = await auth.refreshTokens()

    if (token) {
      if (isLogin) return navigateTo(resolvePostLoginPath(to.query))
      return
    }
  }

  if (!isLogin) return navigateTo(buildLoginLocation(to.fullPath))
}
